import styled from "styled-components";

const Circle = styled.div`
  display: inline-block;
  height: 30px;
  min-width: 30px;
  border-radius: 50%;
  margin-top: 4px;
  text-align: center;
  background: ${(props) => (props.inExclude ? "#FFE0E0" : "#E7EDFF")};
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    height: 24px;
    min-width: 24px;
    margin-top: 2px;
  }
  .text-style {
    color: ${(props) => (props.inExclude ? "#ad0000" : "#001760")};
    font-family: "Roboto";
    font-weight: 700;
    font-size: 12px;
    vertical-align: middle;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 9px;
      margin-left: -1px;
    }
  }
  &:hover {
    cursor: pointer;
  }
`;

const ExtendedKeywordCount = (props) => {
  const { count, inExclude, onClick } = props;
  return (
    <Circle onClick={onClick} inExclude={inExclude}>
      <span className="text-style">{count}</span>
    </Circle>
  );
};

export default ExtendedKeywordCount;
